var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 30"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 19221"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h30v30H0z",
  "data-name": "Rectangle 2366"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  "data-name": "Group 9118"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.505 15h14.989",
  "data-name": "Path 1483"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 22.494V7.505",
  "data-name": "Path 1484"
})))));
export { SvgPlus as ReactComponent };
export default __webpack_public_path__ + "static/media/plus.98d1380d05f360fba4a58c79588171e9.svg";